import useTransportPermitsMatch from './useTransportPermitsMatch';
import moment from 'moment';
import { useSelector } from 'react-redux';

const fromDate = (d) => moment(d).startOf('day').utc().format();
const toDate = (d) => moment(d).endOf('day').utc().format();

const getDateValue = (type, date) => {
  switch (Number(type)) {
    case 1:
      return {
        insertDateFrom: fromDate(date?.[0]),
        insertDateTo: toDate(date?.[1]),
      };
    case 3:
      return {
        actionDateFrom: fromDate(date?.[0]),
        actionDateTo: toDate(date?.[1]),
      };
    case 2:
      return {
        cancellationDateFrom: fromDate(date?.[0]),
        cancellationDateTo: toDate,
      };
    default:
      return {};
  }
};

const filterObject = (obj) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (!!value) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

const useGetParamsForRequest = () => {
  const match = useTransportPermitsMatch();

  const {
    visiblePermitFilter,
    filterChanged,
    searchValue,
    dateRange,
    dateRangeField,
    permitStatusIds,
    ...values
  } = useSelector((state) => state.permitsFilterStore);

  const result = filterObject({
    ...values,
    permitStatusIds: permitStatusIds?.length ? permitStatusIds : undefined,
  });

  const urlCompanyId = match?.params.companyId
    ? Number(match.params.companyId)
    : null;

  const dateValue = getDateValue(dateRangeField, dateRange);

  return { serviceCompanyId: urlCompanyId, ...result, ...dateValue };
};

export default useGetParamsForRequest;
